module.exports = __webpack_public_path__ + "img/officialAccount.5a8b68e3.png";